var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrmAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14,10V0H3V2H2V5H1V16H15V10ZM4,1h9v9H12V2H4ZM3,3h8v7h-.29l-5-5H3ZM14,15H2V6H5.29l5,5H14Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrmAccount);
export default __webpack_public_path__ + "static/media/crm-account.a2e91456.svg";
export { ForwardRef as ReactComponent };